import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { TournamentsService } from '@app/services/tournaments/tournaments.service';
import { ActivatedRoute } from '@angular/router';
import { Tournament } from '@app/_models/tournament.model';
import * as moment from 'moment';
import { Dictionary } from '@app/_models/shared.model';
import { FieldCapacity } from '@app/_models/facilities';
import { ViewChild } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material';
import { TournamentPositionsComponent } from './tournament-positions/tournament-positions.component';

@Component({
  selector: 'tournament-detail',
  templateUrl: './tournament-detail.component.html',
  styleUrls: ['./tournament-detail.component.scss'],
})
export class TournamentDetailComponent implements OnInit {
  constructor(
    private _location: Location,
    private _activatedRoute: ActivatedRoute,
    private _tournamentService: TournamentsService
  ) { }

  @ViewChild(TournamentPositionsComponent, { static: false }) private tournamentPositions: TournamentPositionsComponent;

  days: Dictionary[] = [
    {
      name: 'Lunes',
      value: 1,
    },
    {
      name: 'Martes',
      value: 2,
    },
    {
      name: 'Miercoles',
      value: 3,
    },
    {
      name: 'Jueves',
      value: 4,
    },
    {
      name: 'Viernes',
      value: 5,
    },
    {
      name: 'Sabado',
      value: 6,
    },
    {
      name: 'Domingo',
      value: 7,
    },
  ];
  fieldsCapacities: FieldCapacity[] = [];
  tournamentId: number;
  tournament: Tournament;
  returnToList() {
    this._location.back();
  }

  ngOnInit() {
    this.tournamentId = this._activatedRoute.snapshot.params.id;
    this._tournamentService.getFieldCapacities().subscribe(fieldsCapacities => {
      this.fieldsCapacities = fieldsCapacities;
    });
    this.getTournament();
  }

  onTabChanged(event: MatTabChangeEvent) {
    if (event.index === 2) {
      this.tournamentPositions.getPositions();
    }
  }

  getTournament() {
    this._tournamentService
      .getTournament(this.tournamentId)
      .subscribe(tournament => {
        this.tournament = tournament;
      });
  }

  publishTournament() {
    this._tournamentService.publishTournament(this.tournamentId).subscribe(() => {
      this.getTournament();
    });
  }

  getTournamentDate() {
    return moment(this.tournament.start_date, 'YYYY-MM-DD').format(
      'DD/MM/YYYY'
    );
  }
  getTournamentDays() {
    const selectedDays = [];

    this.days.forEach(day => {
      this.tournament.days.forEach(tournamentDay => {
        if (day.value === tournamentDay) {
          selectedDays.push(day.name);
        }
      });
    });
    return selectedDays.join(', ');
  }

  getTournamentTeamSize(fieldCapacityId: number): number {
    const fieldCapacity = this.fieldsCapacities.find(
      e => e.id === fieldCapacityId
    );
    return parseInt(fieldCapacity.description, 10);
  }
  getTournamentTimes() {
    return `${moment(this.tournament.start_time, 'HH:mm:ss').format(
      'HH:mm'
    )} - ${moment(this.tournament.end_time, 'HH:mm:ss').format('HH:mm')}`;
  }
  getTournamentFee() { }
}
